import React, { useContext } from "react";
import * as FaIcons from "react-icons/fa";

import UserContext from "../../context/users/userContext";

const CreateScharterAssignments = ({
  selectedUser,
  selectedCharters,
  text,
  handleOnChange,
  handleAssignCharter,
  handleRemoveCharter,
  emptySelectedUser,
}) => {
  const userContext = useContext(UserContext);
  const { filteredCharters } = userContext;
  const { FirstName, LastName, Hris_EmailAddres } = selectedUser;
  return (
    <div className="search-user-component">
      <div className="form">
        <div className="title-flex">
          <FaIcons.FaArrowLeft
            className="title-icon"
            onClick={() => emptySelectedUser()}
          />
          <h3 className="text-center">{`Assign Charters for ${FirstName} ${LastName}`}</h3>
          <div style={{ visibility: "hidden" }}>
            <p>Blank</p>
          </div>
        </div>
        <div className="selected-charters">
          {selectedCharters.map((item, index) => {
            return (
              <div className="selected-container">
                <div
                  className="remove-charter"
                  onClick={() => handleRemoveCharter(index)}
                >
                  <FaIcons.FaTimes className="close-icon" />
                </div>
                <div className="selected-charter">{item.name}</div>
              </div>
            );
          })}
        </div>
        <input
          type="search"
          value={text}
          onChange={(e) => handleOnChange(e)}
          placeholder="Search for Charters"
        />
      </div>
      <div className="search-results">
        {filteredCharters.length > 0 ? (
          <ul>
            {filteredCharters.map((item) => {
              const { _id, name, abbreviation } = item;
              return (
                <li
                  onClick={() =>
                    handleAssignCharter({
                      _id,
                      name,
                    })
                  }
                >
                  <div className="top">
                    <FaIcons.FaUniversity className="top-icon" />
                    {`${name} - ${abbreviation}`}
                  </div>
                </li>
              );
            })}
          </ul>
        ) : null}
      </div>
    </div>
  );
};

export default CreateScharterAssignments;
